export const LaborContractEN = {
    "employeeContractConfig": {
        "header": "LABOR CONTRACT SETTINGS",
        "detail": {
            "applyWorkflow": "When this setting is enabled, Contract will be applied approval feature. Only if the contract is approved will all information about jobs, salaries, allowances, etc be updated."
        },
        "title": {
            "settingPatternCode": "Pattern Contract Code Setting",
            "applyWorkflow": "Apply approval process to Contract",
            "laborContractType": "Labor contract type",
            "allowancesType": "Allowances type"
        },
        "btn": {
            "setting": "Cài đặt"
        },
        "message": {
            "add": "Update Success",
            "failed": "Update Failed"
        }
    }
}